'use client'
import React, { useContext, useState } from 'react'
import {
	UsersIcon,
	CreditCardIcon,
	CogIcon,
	LogoutIcon,
	UserIcon,
	MenuIcon,
	ChatAlt2Icon,
} from '@heroicons/react/outline'
import Image from 'next/image'
import clsx from 'clsx'
import AuthContext from '../../context/AuthContext'
import icon from '../../public/icon.svg'
import { logOut } from '../../services/auth'
import SidebarLink from './SidebarLink'
import CompanyButton from './CompanyButton'
import AppDownloadQRCard from './AppDownloadQRCard'

type Props = {
	openDownloadModal: () => void
	subscriptionName: string
}

const Sidebar = ({ openDownloadModal, subscriptionName }: Props) => {
	const [isExpanded, setIsExpanded] = useState(false)
	const authContext = useContext(AuthContext)

	const handleExpand = () => {
		setIsExpanded(!isExpanded)
	}

	return (
		<div className="flex bg-hitemup-green-200 p-4 md:px-6 md:py-8 md:min-h-screen w-full md:w-80 md:fixed top-0 left-0 flex-col h-full">
			<div className="flex items-center space-x-4">
				<div className="bg-hitemup-green text-white rounded-lg flex-none">
					<div className="flex justify-center items-center h-14 w-14">
						<Image src={icon} alt="Hit Em Up" width={32} height={32} />
					</div>
				</div>
				<div className="flex-1">
					<CompanyButton />
					<div className="text-sm text-gray-600">{subscriptionName}</div>
				</div>
				<button className="md:hidden ml-auto" onClick={handleExpand}>
					<MenuIcon className="w-6 h-6" />
				</button>
			</div>

			<div className={clsx({ hidden: !isExpanded }, 'md:flex mt-8 flex-col h-full justify-between')}>
				<div>
					<SidebarLink href="/dashboard/members">
						<UsersIcon className="w-8 h-8 mr-4" />
						Team Members
					</SidebarLink>
					<SidebarLink href="/dashboard/conversations">
						<ChatAlt2Icon className="w-8 h-8 mr-4" />
						Conversations
					</SidebarLink>
					{authContext.isCompanyManager && (
						<SidebarLink href="/dashboard/billing">
							<CreditCardIcon className="w-8 h-8 mr-4" />
							Billing
						</SidebarLink>
					)}
					{
						<SidebarLink href="/dashboard/settings">
							<CogIcon className="w-8 h-8 mr-4" />
							Settings
						</SidebarLink>
					}
				</div>
				<AppDownloadQRCard openDownloadModal={openDownloadModal} />
			</div>

			<div className={clsx({ hidden: !isExpanded }, 'md:block border-t border-white pt-4 mt-4')}>
				<div className="flex items-start mb-4">
					<div className="bg-hitemup-green text-white w-14 h-14 rounded-lg flex items-center justify-center mr-4 shrink-0">
						<UserIcon className="w-8 h-8" />
					</div>
					<div className="flex flex-col overflow-hidden min-w-0 flex-1">
						<span className="font-bold break-words">
							{authContext.user?.firstName} {authContext.user?.lastName}
						</span>
						<span className="text-sm text-gray-600 truncate">{authContext.user?.email}</span>
					</div>
				</div>
				<button className="flex items-center mx-4 text-gray-500 text-sm hover:text-black" onClick={logOut}>
					<LogoutIcon className="w-6 h-6 mr-2" /> Log out
				</button>
			</div>
		</div>
	)
}

export default Sidebar
